module.exports = __webpack_public_path__ + "img/sin-pendientes.242db42e.svg";